/**
 * Collection card badges (image badges, sale badges, discount codes/badges).
 * Runs after Globo Filter re-renders the product grid.
 * Config is provided by the theme via `window.themeBadgeConfig`
 * (see snippets/collection-card-badges-data.liquid).
 * Depends on jQuery and the global `log` helper (snippets/_debug.liquid).
 */
(function () {
  if (typeof window.jQuery === 'undefined') return;

  var logger = window.log || { debug: function () {} };

  window.addEventListener('globoFilterRenderCompleted', function () {
    var cfg = window.themeBadgeConfig || {};
    var colorClass = 'color-' + (cfg.saleBadgeColorScheme || '');

    if (typeof globoswatch !== 'undefined') globoswatch.init();

    // Image badges
    var imageBadges = [];
    if (cfg.imageBadgesEnabled) {
      imageBadges = (cfg.imageBadges || '').split(';');
      $('.card--product').each(function () {
        $(this).append('<div class="image-badge-container--top-left"></div>');
        $(this).append('<div class="image-badge-container--top-right"></div>');
        $(this).append('<div class="image-badge-container--bottom-left"></div>');
        $(this).append('<div class="image-badge-container--bottom-right"></div>');
      });
    }

    $('.card-wrapper').each(function () {
      var productHandle = $(this).data('product-handle');
      imageBadges.forEach((imageBadge) => {
        if (imageBadge.includes(productHandle)) {
          var imageBadgeAr = imageBadge.split(', ');
          var badgePosition = imageBadgeAr[4].toLowerCase().replace(' ', '-');
          var badgeDisableOnProductItems = imageBadgeAr[5];
          var badgeTitle = imageBadgeAr[0];
          var badgeImage = imageBadgeAr[1];
          if (badgeDisableOnProductItems != 'true') {
            var badgeHtml = `<div class="image-badge image-badge cst"><img src="${badgeImage}" alt="${badgeTitle}" width="48" height="48" loading="lazy"></div>`;
            $(this).find(`.card--product .image-badge-container--${badgePosition}`).append(badgeHtml);
          }
        }
      });
    });

    // Sale badges
    if (cfg.saleBadgesEnabled) {
      var saleBadges = (cfg.saleBadges || '').split(';');
      saleBadges = saleBadges.filter((el) => el != '');

      $('.card-wrapper').each(function () {
        var productHandle = $(this).data('product-handle');
        $(this).find('.card__badge .badge--after-load').remove();

        saleBadges.forEach((badge) => {
          if (badge.includes(productHandle)) {
            var badgeAr = badge.split(', ');
            var badgeText = badgeAr[0];
            var textColor = badgeAr[4];
            var bgColor = badgeAr[5];
            var disableOther = badgeAr[6];
            var specialEventsOnly = badgeAr[7];
            var settings_special_events_enabled = cfg.specialEventsEnabled;
            var enableOnCollection = badgeAr[2];
            var display_badge = false;
            for (var i = 8; i < badgeAr.length; i++) {
              if (badgeAr[i] == productHandle) {
                display_badge = true;
              }
            }
            logger.debug('settings_special_events_enabled', settings_special_events_enabled);
            logger.debug('specialEventsOnly', specialEventsOnly);
            logger.debug('badgeText', badgeText);
            var badgeHtml = `<div class="badge badge--bottom-left badge--after-load ${colorClass} cst" style="color: ${textColor}; background-color: ${bgColor};">${badgeText}</div>`;
            logger.debug('enableOnCollection', enableOnCollection);
            if (display_badge == true) {
              if (specialEventsOnly == 'true' && settings_special_events_enabled == false) {
                return;
              }
              if (enableOnCollection == 'true' && disableOther == 'true') {
                $(this).find('.card__badge').html(badgeHtml);
              } else if (enableOnCollection == 'true') {
                $(this).find('.card__badge').append(badgeHtml);
              }
            }
          }
        });
      });
    }

    // Discount codes
    if (cfg.codeDiscountsEnabled) {
      var discountCodes = (cfg.discountCodes || '').split(';');
      logger.debug(discountCodes);

      $('.card-wrapper').each(function () {
        var price = $(this).find('.product-price').data('price');
        var compare_at_price = $(this).find('.product-price').data('compare-at-price');
        var priceVaries = $(this).find('.product-price').data('price-varies') == true ? '+' : '';

        discountCodes.forEach((discountCode) => {
          logger.debug(discountCode);
          if (discountCode.includes($(this).data('product-handle'))) {
            var discountCodeAr = discountCode.split(', ');
            var code = discountCodeAr[0];
            var percentageDiscount = discountCodeAr[2];
            var valueDiscount = discountCodeAr[3] / 100;
            var enableBadge = discountCodeAr[4];
            var badgeText = discountCodeAr[5];
            var badgeBgColor = discountCodeAr[6];
            var badgeTextColor = discountCodeAr[7];
            var updatedPrice = price;

            if (percentageDiscount) {
              updatedPrice = price - (price * percentageDiscount) / 100;
            } else if (valueDiscount) {
              updatedPrice = price - valueDiscount;
            }

            var updatedCompareAtPrice = '';
            if (!compare_at_price) {
              updatedCompareAtPrice = Math.round(price * 100) / 100;
            } else {
              updatedCompareAtPrice = Math.round(compare_at_price * 100) / 100;
            }
            updatedPrice = updatedPrice.toFixed(2);
            updatedCompareAtPrice = updatedCompareAtPrice.toFixed(2);

            if (enableBadge == 'true') {
              var discountHtml = `<span class="badge badge--bottom-left badge--after-load ${colorClass} cst" style="background: ${badgeBgColor}; color: ${badgeTextColor};">${badgeText}</span>`;
              $(this).find('.card__badge').html(discountHtml);
            }
            var discountPrice = `<span class="price price-product__value "><span class="product-price_sale"><del class="product-price_compare"> $${updatedCompareAtPrice}</del><span class="product-lowest-price">$${updatedPrice}${priceVaries}</span> <span class="code-discount-text-coll">with code: '${code}'</span></span></span>`;
            $(this).find('.product-price').html(discountPrice);
          }
        });
      });
    }

    // Discount metaobject badges
    if (cfg.discountsEnabled) {
      var discountBadgeItems = (cfg.discountBadgeItems || '').split(';');

      $('.card-wrapper').each(function () {
        var productHandle = $(this).data('product-handle');
        discountBadgeItems.forEach((discountBadgeItem) => {
          var display_badge = false;
          if (discountBadgeItem.includes(productHandle)) {
            var discountBadgeItemAr = discountBadgeItem.split(', ');
            for (var i = 2; i < discountBadgeItemAr.length; i++) {
              if (discountBadgeItemAr[i] == productHandle) {
                display_badge = true;
              }
            }
            if (display_badge == true && discountBadgeItemAr[0] == 'true') {
              var discountBadge = `<span class="discount_off_text">${discountBadgeItemAr[1]}</span>`;
              if ($(this).find('.product-price .discount_off_text').length <= 0) {
                $(this).find('.product-price').append(discountBadge);
              }
            }
          }
        });
      });
    }
  });
})();
